// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 2.5H9.48063L11.4806 5H23V10.5218C21.9897 9.875 20.7886 9.5 19.5 9.5C15.9101 9.5 13 12.4101 13 16V21H1V2.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22.75 14.75V15.5H23.999V22H14.999V15.5H16.25V14.75C16.25 12.9551 17.7051 11.5 19.5 11.5C21.2949 11.5 22.75 12.9551 22.75 14.75ZM20.75 14.75C20.75 14.0596 20.1904 13.5 19.5 13.5C18.8096 13.5 18.25 14.0596 18.25 14.75V15.5H20.75V14.75Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-locked-filled')
export default class FolderLockedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-locked-filled',
    }
  }
}
